import { TTableListActions } from './tablelist.actions';
import { ITablelistStateItem, TABLELIST_ACTIONS } from '../interfaces';
import { ITablelistState } from './tablelist.state';
import { NAVIGATION_ACTIONS, NavigationCleanUpAction } from '@ispm/navigation/store/navigation.actions';

class InitState implements ITablelistState {
  public list: ITablelistStateItem = { };
  static builder() {
    return new InitState();
  }
}

export function tablelistReducer(state: ITablelistState = InitState.builder(), action: TTableListActions | NavigationCleanUpAction): ITablelistState {
  let newState;
  let payloadValue;

  switch (action.type) {
    case TABLELIST_ACTIONS.INIT:
      return InitState.builder();
    case NAVIGATION_ACTIONS.NAVIGATION_CLEAN_UP: {
      newState = Object.assign(InitState.builder(), state);
      newState.list = { };

      return { ...newState};
    }
    case TABLELIST_ACTIONS.CLEAR: {
      payloadValue = action.payload.getValue();
      newState = Object.assign(InitState.builder(), state);

      if (newState.list[payloadValue.configTemplateType]) {
        newState.list[payloadValue.configTemplateType].ids = [];
        newState.list[payloadValue.configTemplateType].data = [];
        /*amount = null removed for BUG - GEN-84798, this logic need to revisit
        * @himanshu.malvi*/
        // newState.list[payloadValue.configTemplateType].amount = null;
      }

      newState.list[payloadValue.configTemplateType] = { ...newState.list[payloadValue.configTemplateType]};
      newState.list = { ...newState.list};

      return { ...newState};
    }
    case TABLELIST_ACTIONS.CLEAR_IDS: {
      payloadValue = action.payload.getValue();
      newState = Object.assign(InitState.builder(), state);

      if (newState.list[payloadValue.configTemplateType]) {
        newState.list[payloadValue.configTemplateType].ids = [];
      }

      newState.list[payloadValue.configTemplateType] = { ...newState.list[payloadValue.configTemplateType]};
      newState.list = { ...newState.list};

      return { ...newState};
    }
    case TABLELIST_ACTIONS.UPDATE_IDS: {
      payloadValue = action.payload.getValue();
      newState = Object.assign(InitState.builder(), state);

      if (newState.list[payloadValue.configTemplateType]) {
        newState.list[payloadValue.configTemplateType].ids  = [...newState.list[payloadValue.configTemplateType].ids, ...payloadValue.ids];
        newState.list[payloadValue.configTemplateType].loaded = newState.list[payloadValue.configTemplateType].ids.length >= newState.list[payloadValue.configTemplateType].amount;
      }

      newState.list[payloadValue.configTemplateType] = { ...newState.list[payloadValue.configTemplateType]};
      newState.list = { ...newState.list};

      return { ...newState};
    }
    case TABLELIST_ACTIONS.SET_IDS: {
      payloadValue = action.payload.getValue();
      newState = Object.assign(InitState.builder(), state);

      if (newState.list[payloadValue.configTemplateType]) {
        newState.list[payloadValue.configTemplateType].ids  = [];
        newState.list[payloadValue.configTemplateType].ids  = payloadValue.ids;
        newState.list[payloadValue.configTemplateType].loaded = newState.list[payloadValue.configTemplateType].ids.length >= newState.list[payloadValue.configTemplateType].amount;
      }

      newState.list[payloadValue.configTemplateType] = { ...newState.list[payloadValue.configTemplateType]};
      newState.list = { ...newState.list};

      return { ...newState};
    }
    case TABLELIST_ACTIONS.CLEAR_DATA: {
      payloadValue = action.payload.getValue();
      newState = Object.assign(InitState.builder(), state);

      if (newState.list[payloadValue.configTemplateType]) {
        newState.list[payloadValue.configTemplateType].data  = [];
        newState.list[payloadValue.configTemplateType].loaded = newState.list[payloadValue.configTemplateType].ids.length >= newState.list[payloadValue.configTemplateType].amount;
      }

      newState.list[payloadValue.configTemplateType] = { ...newState.list[payloadValue.configTemplateType]};
      newState.list = { ...newState.list};

      return { ...newState};
    }

    case TABLELIST_ACTIONS.SET_CONFIG_TEMPLATE: {
      payloadValue = action.payload.getValue();
      newState = Object.assign(InitState.builder(), state);

      if (newState.list[payloadValue.configTemplateType]) {
        newState.list[payloadValue.configTemplateType].config  = { ...newState.list[payloadValue.configTemplateType].config, ...payloadValue.item};
      } else {
        newState.list[payloadValue.configTemplateType] = {
          config : payloadValue.item || { },
          ids: [],
          data: []
        };
      }

      newState.list[payloadValue.configTemplateType]  = { ...newState.list[payloadValue.configTemplateType]};
      newState.list = { ...newState.list};

      return { ...newState};
    }
    case TABLELIST_ACTIONS.SET_PAGE: {
      payloadValue = action.payload.getValue();
      newState = Object.assign(InitState.builder(), state);
      newState.list[payloadValue.configTemplateType]  = { ...newState.list[payloadValue.configTemplateType]};
      newState.list = { ...newState.list};

      return { ...newState};
    }
    case TABLELIST_ACTIONS.SET_PAGE_DATA: {
      payloadValue = action.payload.getValue();
      newState = Object.assign(InitState.builder(), state);

      if (payloadValue.isClubbed) {
        newState.list[payloadValue.configTemplateType].data = newState.list[payloadValue.configTemplateType].data.concat(payloadValue.items);
      } else {
        newState.list[payloadValue.configTemplateType].data  = { ...newState.list[payloadValue.configTemplateType].data, ...payloadValue.items};
        newState.list[payloadValue.configTemplateType]  = { ...newState.list[payloadValue.configTemplateType]};
        newState.list = { ...newState.list};
      }

      return { ...newState};
    }
    case TABLELIST_ACTIONS.SET_ENTITIES_AMOUNT: {
      payloadValue = action.payload.getValue();
      const resourceName = payloadValue.resourceName;
      delete payloadValue.resourceName;
      state.list[resourceName].loaded = state.list[resourceName].ids.length >= payloadValue.amount;
      state.list[resourceName] = Object.assign({ }, state.list[resourceName], payloadValue);
      state.list = { ...state.list};

      return { ...state};
    }
    case TABLELIST_ACTIONS.SET_IDENTIFIER_DATA: {
      payloadValue = action.payload.getValue();
      const configTemplate = payloadValue.configTemplate;
      state.list[configTemplate].identifierData = payloadValue.aggIds;
      return { ...state};
    }
    case TABLELIST_ACTIONS.CLEAR_IDENTIFIER_DATA: {
      payloadValue = action.payload.getValue();
      newState = Object.assign(InitState.builder(), state);
      if (newState.list[payloadValue.configTemplateType]) {
        newState.list[payloadValue.configTemplateType].identifierData = {};
      }

      newState.list[payloadValue.configTemplateType] = { ...newState.list[payloadValue.configTemplateType]};
      newState.list = { ...newState.list};

      return { ...newState};
    }
    default:
      return state;
  }
}
